import { DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutGeographicCity extends Layout {
    panelMain: Panel;
    sourceGeographicCity: DataSource;
    switchStatus: Switch;
    textboxAirportCode: Textbox;
    textboxCounty: Textbox;
    textboxLatitude: Textbox;
    textboxLongitude: Textbox;
    textboxName: Textbox;
    textboxNumber: Textbox;
    textboxStateId: Textbox;
    textboxThreeDigitZip: Textbox;
    textboxTimezoneId: Textbox;
    textboxZipCode: Textbox;
    textboxZoneId: Textbox;
}
